import { useContext, useEffect, useState } from "react";
import { fetchProject } from "../../../../services/Candidate/Profile/fetchCandidateDetails";
import { DContext } from "../../../../../context/Datacontext";
import { FiEdit2 } from "react-icons/fi";
import { useLocation, useNavigate } from "react-router-dom";


function Projects({ candidate, setViewData, setPopupTitle, currentUser }) {

  const { BeURL, showAlert } = useContext(DContext)

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(3);
  const [totalItems, setTotalItems] = useState(0)
  const [totalPage, setTotalPage] = useState(0);
  const [projects, setProjects] = useState(null)
  const [loading, setLoading] = useState(false)

  const navigate = useNavigate()
  const location = useLocation()


  useEffect(() => {
    if (BeURL && currentPage && itemsPerPage) {
      setLoading(true)

      fetchProject(BeURL, candidate._id, currentPage, itemsPerPage, setTotalItems, setTotalPage, setProjects, showAlert,setLoading)
    }
  }, [currentPage, itemsPerPage, BeURL])

  useEffect(() => {
    setCurrentPage(1)
  }, [itemsPerPage])

  const handlePopupView = (p) => {
    const viewData = {
      Name: p.projectName || "",
      ["Client name"]: p.clientName || "",
      From: p.periodFrom || "",
      To: p.periodTo || "",
      Location: p.location || "",
      Ongoing: p.isProcessing || "",
      Description: p.description || "",
      Role: p.role || "",
      Link: p.link || ""
    }

    setPopupTitle("Project")
    setViewData(viewData)
  }

  if (loading) {
 
    return <div className="my-3 bg-white p-2 rounded-xl">Loading...</div>
  }

  return (
    <div className="my-3 bg-white p-2 rounded-xl w-full lg:w-[49%]">
      {/* */}
      <div className="flex justify-between items-end"><h3 className="font-semibold text-lg  mt-4">Projects</h3>
     <FiEdit2 className="text-primary-500 text-xl font-bold" onClick={() => navigate(`/update-account/highlights?inverse=${true}&candidateId=${candidate._id}`, { state: { from: location.pathname, active: 'Highlights' } })} /></div>
      <div className="my-2 min-h-[20vh] overflow-x-auto">
        <table className="border-separate border-spacing-y-1 w-full table-fixed">
          <thead>
            <tr className="text-left mb-2 rounded-lg">
              <th className="font-medium text-sm px-2 py-2 bg-purple-50 text-secondary-300 rounded-l-lg">Name</th>
              <th className="font-medium text-sm px-2 py-2 bg-purple-50 text-secondary-300 hidden md:table-cell">Client name</th>
              <th className="font-medium text-sm px-2 py-2 bg-purple-50 text-secondary-300">Role</th>
              <th className="font-medium text-sm px-2 py-2 bg-purple-50 text-secondary-300 rounded-r-lg">Action</th>
            </tr>
          </thead>
          <tbody>
            {
              projects?.length > 0 ?
                projects.map((p, i) => (
                  <tr className="rounded-lg" key={i}>
                    <td className="text-sm px-2  rounded-l-lg  truncate whitespace-nowrap overflow-hidden">{p.projectName}</td>
                    <td className="text-sm px-2 hidden md:table-cell truncate whitespace-nowrap overflow-hidden">{p.clientName || "-"}</td>
                    <td className="text-sm px-2  truncate whitespace-nowrap overflow-hidden">{p.role || "-"}</td>
                    <td className="text-sm px-2 rounded-r-lg truncate whitespace-nowrap overflow-hidden">
                      <div className="flex items-center">
                        <span className="bg-purple-50 text-secondary-300 px-3 py-1 text-sm rounded-lg cursor-pointer" onClick={() => handlePopupView(p)}>View</span>
                      </div>
                    </td>
                  </tr>
                ))
                :
                (!loading && <tr>
                  <td colSpan={4} className="text-center text-sm">
                    No Data available!
                  </td>
                </tr>)
            }

          </tbody>
        </table>
      </div>

      <div className=" flex flex-row items-center justify-between gap-5">
        <div className="flex items-center justify-center gap-2 flex-1">
          <label className="text-xs">Page</label>
          <select value={itemsPerPage} onChange={e => setItemsPerPage(Number(e.target.value))} className="border rounded-lg px-2 py-1 text-xs">
            <option value={3}>3</option>
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={15}>15</option>
          </select>
        </div>

        <div className="flex items-center justify-center gap-2 flex-1 text-xs">
          <button
            onClick={() => setCurrentPage((currentPage <= 1) ? 1 : currentPage - 1)}
            disabled={currentPage <= 1}
            className={`px-2 py-1 rounded-lg border ${currentPage <= 1 ? "opacity-50 cursor-not-allowed" : "bg-slate-500 text-white"}`}
          >
            Prev
          </button>

          <span className="min-w-fit">{currentPage} of {totalPage || 1}</span>

          <button
            onClick={() => setCurrentPage((currentPage >= totalPage) ? totalPage : currentPage + 1)}
            disabled={currentPage >= (totalPage || 1)}
            className={`px-2 py-1 rounded-lg border ${currentPage >= (totalPage || 1) ? "opacity-50 cursor-not-allowed" : "bg-slate-500 text-white"}`}
          >
            Next
          </button>
        </div>

        <div className="text-xs text-slate-600 flex-1 text-center">
          Total {totalItems || 0} 
        </div>
      </div>

    </div>
  )
}

export default Projects